import { getStoreId } from "$/hooks/use-store-information"
import customBookingSectionQueries from "$/lib/queries/custom-booking-section-queries"
import feeQueries from "$/lib/queries/fee-queries"
import { receptionDataQueryOptions } from "$/lib/queries/reception-queries"
import servicePackageQueries from "$/lib/queries/service-package-queries"
import storeQueries from "$/lib/queries/store-queries"
import washQueries from "$/lib/queries/wash-queries"
import { requireNonFreeTier } from "$/lib/require-non-free-tier"
import { QueryClient } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { z } from "zod"

const searchSchema = z.object({
  serviceDay: z.string().optional(),
  eventId: z.guid().optional(),
})

export const Route = createFileRoute("/(app)/_auth/jobs/new-reception")({
  validateSearch: searchSchema,
  loader: async ({ context: { queryClient } }) => {
    await requireNonFreeTier(queryClient)
    const storeId = await getStoreId()

    if (storeId) prefetch(queryClient, storeId)

    return {
      crumb: "alfred.jobs.reception.crumb",
    }
  },
})

function prefetch(queryClient: QueryClient, storeId: string) {
  queryClient.prefetchQuery(receptionDataQueryOptions(storeId))
  queryClient.prefetchQuery(servicePackageQueries.list({ storeId }))
  queryClient.prefetchQuery(washQueries.list({ storeId }))
  queryClient.prefetchQuery(feeQueries.list({ storeId }))
  queryClient.prefetchQuery(storeQueries.detail(storeId))
  queryClient.prefetchQuery(customBookingSectionQueries.list({ storeId }))
}
